import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Badge } from "@fronterahealth/frontera-ui-components/ui/badge";

import { useReviewChip } from "@components/ReportReview/hooks/useReviewChip";

export const ReviewChip: React.FC = () => {
  const chip = useReviewChip();
  if (!chip) return null;

  return (
    <Badge
      variant="outline"
      size="sm"
      className={cn(chip.tone === "sentBack" ? "bg-amber-100 text-amber-800" : "bg-blurple-50 text-blurple-700")}
    >
      {chip.label}
    </Badge>
  );
};
